import { JsonServiceClient } from '@servicestack/client';
import { useMemo } from 'react';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { client } from '../api/client';
import { GetRegistrationPackages, GetRegistrationPackagesResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';
import { immerable } from 'immer';

const getData = (response?: SWRResponse<GetRegistrationPackagesResponse, GetRegistrationPackagesResponse>) => response?.data?.packages;

const getError = (response?: SWRResponse<GetRegistrationPackagesResponse, GetRegistrationPackagesResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetRegistrationPackagesResponse, GetRegistrationPackagesResponse>) => ({
    packages: response?.data?.packages,
});

export const useAvailablePackages = (
    member?: number, 
    tc?: boolean, 
    std?: boolean, 
    reg?: boolean, 
    staff?: boolean, 
    attendeeFromJapanOrKorea?: boolean, 
    sponsor?: boolean, 
    freeSponsorRegistration?: boolean, 
    isSac?: boolean, 
    isCap?: boolean,
    isSpeaker?: boolean,
    configuration?: SWRConfiguration
) => {

    const request = useMemo(() => {

        return () => {
            return new GetRegistrationPackages({
                member, 
                restrictToTc: tc, 
                restrictToStudent: std, 
                restrictToRegistrar: reg, 
                staff, 
                attendeeFromJapanOrKorea, 
                sponsor, 
                freeSponsorRegistration, 
                isSac, 
                isCap,
                isSpeaker
            });
        };
    }, [member, tc, std, reg, staff, attendeeFromJapanOrKorea, sponsor, freeSponsorRegistration, isSac, isCap, isSpeaker])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useAvailablePackages;